import {
  formatDateDayMonth,
  formatDateDayMonthTime,
  formatDateMonth,
} from "../";

export const formatDateBySegmentNoYear = (
  date: Date | string,
  segment: string,
) => {
  const normalizedDate = date instanceof Date ? date : new Date(date);
  let returnDate = "";

  switch (segment) {
    case "year":
    case "m":
      returnDate = formatDateMonth(normalizedDate);
      break;
    case "month":
    case "d":
      returnDate = formatDateDayMonth(normalizedDate);
      break;
    case "day":
    case "h":
      returnDate = formatDateDayMonthTime(normalizedDate);
      break;
    default:
      break;
  }

  return returnDate;
};
